// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TP3h","option":"styles_option__bBziX","active":"styles_active__IQDE8"};